import axiosInstance from "../variables/api/axiosInstance";

export const habilitationsService = {
    /** Liste toutes les habilitations actives */
    list: () => axiosInstance.get('/v1/habilitations'),

    /** Habilitations d'un module */
    byModule: (moduleTrackingId) =>
        axiosInstance.get(`/v1/habilitations/module/${moduleTrackingId}`),

    /** Détail d'une habilitation */
    get: (trackingId) => axiosInstance.get(`/v1/habilitations/${trackingId}`),

    /** Créer une habilitation */
    create: (data) => axiosInstance.post('/v1/habilitations', data),

    /** Modifier une habilitation */
    update: (trackingId, data) =>
        axiosInstance.put(`/v1/habilitations/${trackingId}`, data),

    /** Suppression logique */
    delete: (trackingId) => axiosInstance.delete(`/v1/habilitations/${trackingId}`),

    /** Import depuis un fichier xlsx (multipart/form-data) */
    import: (file) => {
        const form = new FormData();
        form.append('file', file);
        return axiosInstance.post('/v1/habilitations/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    /** Téléchargement du template xlsx */
    downloadTemplate: () =>
        axiosInstance.get('/v1/habilitations/template', { responseType: 'blob' }),
};